import { Component, EventEmitter, Input, Output, ElementRef, HostListener } from '@angular/core';
import { REQUEST_COLORS } from 'src/app/request-v2/constants/request-colors.constants';
import { ICON_FR_KEYWORDS } from 'src/app/request-v2/constants/icon-labels.constants';

@Component({
    selector: 'app-icon-color-selector',
    templateUrl: './icon-color-selector.component.html',
    styleUrls: ['./icon-color-selector.component.scss'],
})
export class IconColorSelectorComponent {
    private _isVisible = false;

    @Input() set isVisible(value: boolean) {
        if (value && !this._isVisible) this.searchQuery = '';
        this._isVisible = value;
    }

    get isVisible(): boolean {
        return this._isVisible;
    }

    @Input() selectedIcon: string;

    @Input() selectedColor = REQUEST_COLORS[0];

    @Input() icons: string[] = [];

    @Input() colors: string[] = [];

    @Output() iconSelect = new EventEmitter<string>();

    @Output() colorSelect = new EventEmitter<string>();

    @Output() close = new EventEmitter<void>();

    searchQuery = '';

    constructor(private elementRef: ElementRef) {}

    get filteredIcons(): string[] {
        if (!this.searchQuery) return this.icons;
        const query = this.searchQuery.toLowerCase().trim();
        return this.icons.filter((icon) => {
            const words = icon.replace('icon-', '').split('-');
            if (words.some((word) => word.startsWith(query))) return true;
            const frKeywords = ICON_FR_KEYWORDS[icon] ?? [];
            return frKeywords.some((kw) => kw.includes(query));
        });
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent): void {
        const clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside && this.isVisible) {
            this.close.emit();
        }
    }

    onIconSelect(icon: string, event: Event): void {
        event.stopPropagation();
        this.iconSelect.emit(icon);
    }

    onColorSelect(color: string, event: Event): void {
        event.stopPropagation();
        this.colorSelect.emit(color);
    }
}
